<template>
  <ul id="list-tasks">
    <li>
      <div class="oblea" @click="selectItem">
        <div id="imagenProductoContainer">
          <img id="check" src="/dist/icon-check.png"  v-show="item.showCheck" />
          <img id="imagenPlaceholder" src="/dist/progress-item.gif"  v-show='imagenProducto == null'  style="width:40px; height:40px;" />
          <img id="imagenProducto" :src="imagenProducto" :title="item.Nombre"  v-show='imagenProducto != null'/>
        </div>
        <p id="labelProducto">{{item.Nombre}}</p>
      </div>
    </li>
  </ul>
</template>


<script>
  import axios from 'axios'

  export default {
    name: 'item-realizar-pedido',
    props: ['item'],
    data() {
      return {

      }
    },

    computed: {

      precio() {
        return  this.item.Precio*(this.item.DevolucionPorcentaje/100)
      },

    //   precio() {
    //     var precioFinal = this.item.Precio*(this.item.DevolucionPorcentaje/100)
    //     return precioFinal * (1 + (this.item.PorcentajeImpuesto/100))
    //   },

      showPorcentaje() {
        if (this.$store.state.pedido.seleccion == 3) {
          return true;
        }
      },

      showNombre() {
        if ((this.$store.state.pedido.seleccion == 1) || (this.$store.state.pedido.seleccion == 2))
        {
          return false;
        }
        else
        {
          return true;
        }
      },

    },

    watch: {
      item: {
        immediate: true,
        handler  () {

        }
      }
    },


    computed: {
      imagenProducto() {
        if ((this.item.ImagenUrl != null) && (this.item.ImagenUrl != '')) {
          return this.item.ImagenUrl
        }
        else {
          return '/dist/placeholder-producto.png'
        }
      }, 
    },



    methods: {
      selectItem () {
         this.$emit('setItem', this.item.Id);
      }
    },

    created () {
     // console.log(this.item)
    },

   }
</script>



<style scoped>


#check{
    position: absolute;
    width: 20px;
    left: 117px;
    top: 5px;
    z-index: 1;
    display: block;
  }


#imagenProductoContainer{
    width: 110px;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    border-width: 1px;
    border: 1px solid #dddddd;
    padding: 10px 15px 10px 15px;
    box-shadow: 4px 4px 7px #dddddd;
  }


#imagenProducto{
    position: relative;
    max-width: 100%;
    max-height: 100%;
    margin: 0 auto;
    display: block;
    border-radius: 10 px;
  }


 * {
   margin:  0;
   padding: 0;
  }


  li {
   float: left;
   display: block;
   padding: 10px;
   text-decoration: none;
  }

.oblea{
    position: relative;
    width: 130px;
    height: 165px;
    background: #ffffff;
  }

  #imagenProductoContainer:hover{
    cursor: pointer;
    background: #f9f9f9;
  }

#labelProducto{
  margin-top: 8px;
  text-align: center;
  font-size:10px;
  font-weight: 500;
  background-color: #ffffff;
  color: #4969B2;
  }

#labelPrecio{
  margin-top: 1px;
  text-align: center;
  font-size:10px;
  font-weight: 600;
  background-color: #ffffff;
  color: #F7A541;
  }


 </style>



// WEBPACK FOOTER //
// src/components/views/realizarDevolucion/itemRealizarDevolucion.vue